export { APP_NAME } from '../../constants/federation';
export const COMPONENTS = {
  MODAL: 'AssetAcquisitionModal',
  CARD: 'AssetAcquisitionCard',
  GEN: 'GenAssetAcquisitionCard',
};
